import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { visuallyHidden } from '@noths/polaris-client-styles';
import { IconClose } from "../../foundations/Iconography/IconClose";
import { IconError } from "../../foundations/Iconography/IconError";
import { IconInfo } from "../../foundations/Iconography/IconInfo";
import { IconWarning } from "../../foundations/Iconography/IconWarning";
import * as styles from "./Notification.styles";
var text = theme.text;
var DEFAULT_TEXT_SIZE = 'SM';
var renderIcon = function renderIcon(status) {
  switch (status) {
    case 'info':
      return /*#__PURE__*/React.createElement(_StyledIconInfo, {
        height: 24,
        width: 24,
        $_css: styles.icon
      });
    case 'alert':
      return /*#__PURE__*/React.createElement(_StyledIconError, {
        color: "var(--neutral-black-base)",
        height: 24,
        width: 24,
        $_css2: styles.icon
      });
    case 'warning':
      return /*#__PURE__*/React.createElement(_StyledIconWarning, {
        height: 24,
        width: 24,
        $_css3: styles.icon
      });
    default:
      return null;
  }
};
export var AnchoredNotification = function AnchoredNotification(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    status = _ref.status,
    _ref$textSize = _ref.textSize,
    textSize = _ref$textSize === void 0 ? DEFAULT_TEXT_SIZE : _ref$textSize;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css4: [styles.wrapper, styles.status[status] || styles.status.default, styles.anchored]
  }, renderIcon(status), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css5: [styles.message, fontSize(text.BODY[textSize])]
  }, children), /*#__PURE__*/React.createElement(_StyledButton, {
    onClick: onClose,
    tabIndex: 0,
    $_css6: styles.iconButton
  }, /*#__PURE__*/React.createElement(_StyledIconClose, {
    height: 24,
    width: 24,
    $_css7: styles.icon
  }), /*#__PURE__*/React.createElement(_StyledSpan, null, "Close Button")));
};
export var Notification = function Notification(_ref2) {
  var children = _ref2.children,
    status = _ref2.status,
    _ref2$textSize = _ref2.textSize,
    textSize = _ref2$textSize === void 0 ? DEFAULT_TEXT_SIZE : _ref2$textSize;
  return /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css8: [styles.wrapper, styles.status[status] || styles.status.default]
  }, renderIcon(status), /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css9: [styles.message, fontSize(text.BODY[textSize])]
  }, children));
};
var _StyledIconInfo = _styled(IconInfo)(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledIconError = _styled2(IconError)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledIconWarning = _styled3(IconWarning)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledDiv2 = _styled5("div")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledButton = _styled6("button")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledIconClose = _styled7(IconClose)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css7;
});
var _StyledSpan = _styled8("span")(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["", ""])), visuallyHidden);
var _StyledDiv3 = _styled9("div")(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css8;
});
var _StyledDiv4 = /*#__PURE__*/_styled10("div").withConfig({
  displayName: "Notification___StyledDiv4",
  componentId: "sc-atfexr-0"
})(["", ""], function (p) {
  return p.$_css9;
});